module.exports = __webpack_public_path__ + "img/orange_055.3b4f2550.png";